// The Accelerator home's sections in the published layout's order (src/product/layout.js resolves
// it; MASTERMIND_HOME is the default), drawn in the board's rows: on a laptop, sections that sit side
// by side share a row, the main one on the left and the side ones stacked on the right, and a main
// section after a side one starts a new row. So the goal sits beside the next session (the 2 cards
// the same height, as Accelerator.dc.html draws them), and this month's actions beside the group and
// the wins (each its own height). Below 1100px, and on a phone, every section is 1 column, with the goal and its
// log button, the next session, the refocus card and this month's actions first (stack: bands.js stackedKeys, Adam's
// answer to the critique's question 4, 20 Oct), then the rest in the layout's order. The laptop stays as signed off.
//
//   parts: { key: { place: 'full' | 'main' | 'side', columns, stretch, when, render } }
//   stack: the keys that lead on stacked widths, in order (a part that isn't a layout section among them)
import { useMedia } from '../../lib/media.js'
import { STACK_QUERY } from '../../product/Layout.jsx'
import { rowBands, stackedKeys } from './bands.js'

export function HomeSections({ sections, parts, stack = [] }) {
  const stacked = useMedia(STACK_QUERY)
  if (!sections) return null
  if (stacked) {
    return (
      <div className="acc-sections acc-sections--stack">
        {stackedKeys(sections, parts, stack).map(key => <Section key={key} id={key} part={parts[key]} />)}
      </div>
    )
  }
  return (
    <div className="acc-sections">
      {rowBands(sections, parts).map(b => {
        if (b.full) return <Section key={b.full} id={b.full} part={parts[b.full]} />
        const both = b.main.length > 0 && b.side.length > 0
        const cls = ['acc-band', both ? '' : 'acc-band--single', b.stretch ? 'acc-band--stretch' : ''].filter(Boolean).join(' ')
        // keyed by its first section, not its place: a section that shows up later above it (Adam's
        // announcement, once the Library has loaded) mustn't redraw the row and lose what's open in it
        // (a win half typed)
        return (
          <div key={`band-${b.main[0] || b.side[0]}`} className={cls} style={both && b.columns ? { gridTemplateColumns: b.columns } : undefined}>
            {b.main.length > 0 && <div className="acc-band-col">{b.main.map(k => <Section key={k} id={k} part={parts[k]} />)}</div>}
            {b.side.length > 0 && <div className="acc-band-col">{b.side.map(k => <Section key={k} id={k} part={parts[k]} />)}</div>}
          </div>
        )
      })}
    </div>
  )
}

function Section({ id, part }) {
  return <div className="acc-section" data-section={id}>{part.render()}</div>
}
